// extracted by mini-css-extract-plugin
export default {"Content":"Menu_Content__pZ8aq","ButtonMenu":"Menu_ButtonMenu__lMtDO","DesktopOnly":"Menu_DesktopOnly__4tRzP","ItemMenu":"Menu_ItemMenu__kCBP9"};